import SocialLegend from './socialLegend'

export default SocialLegend
